export const services = [
  {
    id: 'paver-driveways',
    title: 'Paver Driveways',
    description: 'Custom driveway paver systems designed for curb appeal, durability, and long-term performance.',
    image: 'https://www.parksidepavers.com/files/projects/14/images/thumb/thumb_large_IMG%5F2835%2Ejpg',
    slug: '/services/paver-driveways',
    icon: 'ri-road-map-line',
  },
  {
    id: 'paver-patios',
    title: 'Paver Patios',
    description: 'Beautiful outdoor patio spaces built with premium interlocking pavers for lasting quality.',
    image: 'https://www.parksidepavers.com/files/projects/15/images/thumb/thumb_large_Albano%2Dlanai%2Ejpg',
    slug: '/services/paver-patios',
    icon: 'ri-home-4-line',
  },
  {
    id: 'walkways',
    title: 'Walkways & Pathways',
    description: 'Elegant walkway and pathway designs that guide guests through your property with style.',
    image: 'https://www.parksidepavers.com/files/projects/17/images/thumb/thumb_large_IMG%5F0274%2EJPG',
    slug: '/services/walkways',
    icon: 'ri-walk-line',
  },
  {
    id: 'pool-deck',
    title: 'Pool Deck Pavers',
    description: 'Slip-resistant, heat-reflective paver surfaces perfect for Florida pool environments.',
    image: 'https://www.parksidepavers.com/files/projects/15/thumb/thumb_Albano%2Dlanai%2Dlanding%2Ejpg',
    slug: '/services/pool-deck',
    icon: 'ri-water-flash-line',
  },
  {
    id: 'retaining-walls',
    title: 'Retaining Walls',
    description: 'Structurally sound retaining walls that manage grade changes while enhancing your landscape.',
    image: 'https://www.parksidepavers.com/files/projects/16/images/thumb/thumb_large_IMG%5F2840%2Ejpg',
    slug: '/services/retaining-walls',
    icon: 'ri-layout-column-line',
  },
  {
    id: 'outdoor-living',
    title: 'Outdoor Living Spaces',
    description: 'Complete outdoor living environments including seating walls, fire features, and entertainment areas.',
    image: 'https://www.parksidepavers.com/files/projects/14/thumb/thumb_IMG%5F2835%2Dlanding%2Ejpg',
    slug: '/services/outdoor-living',
    icon: 'ri-fire-line',
  },
  {
    id: 'hardscape-design',
    title: 'Hardscape Design & Installation',
    description: 'End-to-end hardscape design and professional installation for residential and commercial properties.',
    image: 'https://www.parksidepavers.com/files/projects/16/thumb/thumb_IMG%5F2840%2Dlanding%2Ejpg',
    slug: '/services/hardscape-design',
    icon: 'ri-ruler-2-line',
  },
];
